/** @format */

import { JDMta } from '@jdreact/jdreact-core-lib';

const event_idExStr = 'Productdetail';
export const PageId = `${event_idExStr}_MainPage`;
//点击
//商品对比—开始对比点击
export const ContrastPop = `${event_idExStr}_ContrastPop`;
//商品对比—立即添加点击
export const ContrastAdd = `${event_idExStr}_ContrastAdd`;
//商品对比—TAB点击
export const ContrastTab = `${event_idExStr}_ContrastTab`;
//商品对比—隐藏相同属性点击
export const ContrastHide = `${event_idExStr}_ContrastHide`;
// 商品对比—弹层底部确定点击
export const ContrastSpecConfirm = `${event_idExStr}_ContrastSpecConfirm`;
//商品对比—右上角分享
export const ContrastShare = `${event_idExStr}_ContrastShare`;
//商品对比—切类目入口点击
export const ContrastCateEntry = `${event_idExStr}_ContrastCateEntry`;
//商品对比—切类目点击
export const ContrastCate = `${event_idExStr}_ContrastCate`;
//商品对比—右下角'我的对比'点击
export const ContrastMine = `${event_idExStr}_ContrastMine`;
//商品对比—图片点击
export const ContrastPhoto = `${event_idExStr}_ContrastPhoto`;
//商品对比—标题点击
export const ContrastWord = `${event_idExStr}_ContrastWord`;
//商品对比—'+'点击
export const ContrastPlus = `${event_idExStr}_ContrastPlus`;
//商品对比—关闭点击
export const ContrastClose = `${event_idExStr}_ContrastClose`;
//商品对比—预估优惠楼层点击
export const ContrastBenefits = `${event_idExStr}_ContrastBenefits`;
//商品对比—优惠券立即领取点击
export const ContrastCoupon = `${event_idExStr}_ContrastCoupon`;
//商品对比—优惠券弹层确定点击
export const ContrastConfirm = `${event_idExStr}_ContrastConfirm`;
//商品对比—商品对比tab点击(外观/基本参数/商品口碑)
export const ContrastProductTab = `${event_idExStr}_ContrastProductTab`;
//曝光
///商品对比—开始对比弹层曝光/
export const ContrastPopExpo = `${event_idExStr}_ContrastPopExpo`;
///商品对比—添加商品页曝光/
export const ContrastAddExpo = `${event_idExStr}_ContrastAddExpo`;
///商品对比—预估优惠楼层曝光/
export const ContrastBenefitsExpo = `${event_idExStr}_ContrastBenefitsExpo`;
// /商品对比—右下角'我的对比'曝光/;
export const ContrastMineExpo = `${event_idExStr}_ContrastMineExpo`;
interface logClickParams {
  event_id: string;
  event_param: string;
  page_param: string;
}
export const logClick = (json: logClickParams) => {
  return JDMta.sendClickData(
    json.event_id ? json.event_id : '',
    json.event_param ? JSON.stringify(json.event_param) : '',
    'onClick',
    '',
    json.page_param ? json.page_param : '',
    '',
    PageId,
    ''
  );
};
